module.exports = __webpack_public_path__ + "static/img/lzwd.a9c7dc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lzwd.png
// module id = qWij
// module chunks = 1